import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'atlassian-navigation.plans.menu.premium-feature-gate.title',
		defaultMessage: 'Unlock advanced planning tools',
		description:
			'Heading of the content of the "Plans" menu for Standard or Free edition, inviting users to upgrade to Premium.',
	},
	imageAlt: {
		id: 'atlassian-navigation.plans.menu.premium-feature-gate.image-alt',
		defaultMessage: 'Upgrade to Jira Premium',
		description: 'Alt text for upgrade to premium plans menu.',
	},
	description: {
		id: 'atlassian-navigation.plans.menu.premium-feature-gate.description',
		defaultMessage:
			"Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools.",
		description:
			'Description of the Jira Software Premium instance advantages, with focus on plans.',
	},
	learnMoreLink: {
		id: 'atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link',
		defaultMessage: 'Read the guide',
		description: 'Link to learn more about Jira Software Premium.',
	},
	startTrialButton: {
		id: 'atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button',
		defaultMessage: 'Try it free',
		description: 'Button to try Jira Software Premium.',
	},
});
